module.exports = __webpack_public_path__ + "img/sc-1.bd6270d3.png";